import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../../commonFunctions";
  const hr21 = {
    label: "Create Approval Flow",
    pageLabel: "Create Approval Flow",
    starting: true,
    url: "hr21",
    pageType: "history",
    form: [
      
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "Description",
        label: "Description",
        name: "Description",
        description: "Enter Description"
      },
      {
        inputType: "text",
        isRequired: true,
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "Description",
        name: "Description",
        description: "Enter Description"
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-6",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Posting Dates",
        name: "",
        description: ""
      },
      {
        inputType: "date",
        dateType: "ontype",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        displayFormat: "DD/MM/YYYY",
        outputFormat: "YYYYMMDD",
        placeHolder: "",
        label: "",
        name: "postingfrom",
        description: ""
      },
      {
        inputType: "date",
        dateType: "ontype",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        displayFormat: "DD/MM/YYYY",
        outputFormat: "YYYYMMDD",
        placeHolder: "",
        label: "",
        name: "postingto",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-6",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        placeHolder: "Set-Active",
        label: "Set-Active",
        name: "Set_Active",
        description: "Active"
      },
      {
        inputType: "handsonTable",
        widths: {
          parent: "col-sm-8",
          children: "col-sm-12"
        },
        name: "workflow",
        description: "none",
        tableOptions: {
          // validations, basic calculations, colors, date pickers, context menu etc.
          HOTheaders: ["User Role", "Purpose.", "Limit Authorize"],
          columns: [{}, {}, {}],
          rowHeaders: false,
          // contextMenu: true,
          minSpareRows: 4,
          stretchH: "last",
          // columnSorting: true,
          autoWrapRow: true,
          maxRows: 100
        }
      }
    ]
  };
  export default hr21;
  